module.exports = __webpack_public_path__ + "static/media/2 (1).91f4607a.jpg";